import React from 'react';
import { cn } from '@/utils/cn';
import Text from '../Text';

function OutOfStock({
  label = 'Out of Stock',
  className = '',
  disabled = false,
  ...rest
}) {
  return (
    <button
      type="button"
      className={cn(
        'bg-aquarelle-purple border-himalayan-poppy border-[1px] w-[124px] lg:w-[200px] h-[24px] lg:h-[36px] rounded-[100px] px-16',
        className,
      )}
      disabled={disabled}
      {...rest}
    >
      <Text
        type="paragraph"
        className={cn(
          'text-xs lg:text-base font-semibold lg:font-bold text-atelier text-center',
        )}
      >
        {label}
      </Text>
    </button>
  );
}

export default OutOfStock;
